module.exports = __webpack_public_path__ + "static/srm-14ffb3dd36b82a62a8fcf60decff2e58.png";